
import { PageHeader } from "@/components/PageHeader";
import { WhatIsAIMAA } from "@/components/about/WhatIsAIMAA";
import { HowAIMAAWorks } from "@/components/about/HowAIMAAWorks";
import { WhyAIMAA } from "@/components/about/WhyAIMAA";
import { ComparisonTable } from "@/components/about/ComparisonTable";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-white">
      <PageHeader 
        title="About"
        description="Explore AIMAA and its impact on AI adoption"
        breadcrumbs={[
          { title: "Home", href: "/" },
          { title: "About" }
        ]}
      />
      
      <div className="container mx-auto max-w-4xl px-4 py-8 sm:py-12">
        <WhatIsAIMAA />
        <HowAIMAAWorks />
        <WhyAIMAA />
        <ComparisonTable />
      </div>
    </div>
  );
};

export default About;
